
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.426 5.971l4.278-4.258a1 1 0 000-1.419 1.012 1.012 0 00-1.426 0L5.999 4.552 1.721.294a1.012 1.012 0 00-1.426 0 1 1 0 000 1.42L4.573 5.97.295 10.23a1 1 0 000 1.419 1.012 1.012 0 001.426 0L6 7.39l4.279 4.258a1.012 1.012 0 001.426 0 1 1 0 000-1.42L7.426 5.972z"}})])
          )
        }
      }
    